module.exports = __webpack_public_path__ + "static/media/Locker.6d45ad7d.png";